import React from 'react'
import './Coding.css'
const Template = () => {
    return (
       <div className='container'>
           <h1 className='text-center'>Template of C</h1>
           <h3 className='text-center' style={{marginBottom:100}}> This the basic template of C that this will made every time when you do a program of C</h3>
         <div className='container'>
           <div className='containers'>
           <code class="library">#include &lt;stdio.h&gt;</code> <br />
           <code className='keywords'>int</code> main()<br />
           <code>&#123;	</code><br />
           <code className= 'library'> printf </code> ("Hello, World!");<br />
           <code>return 0 <br /> &#125;</code><br />
            
           </div>
           </div>
           <p>Beginning with C programming: 
 

 Structure of a C program 
 After the above discussion, we can formally assess the structure of a C program. By structure, it is meant that any program can be written in this structure only. Writing a C program in any other structure will hence lead to a Compilation Error.
 The structure of a C program is as follows:</p>
 <ol> <h5>Let us analyze the program line by line</h5>
 <li> <b> Line 1: [ #include &lt;stdio.h&gt; ]</b> In a C program, all lines that start with # are processed by a preprocessor which is a program invoked by the compiler. In a very basic term, the preprocessor takes a C program and produces another C program.
  The produced program has no lines starting with #, all such lines are processed by the preprocessor. In the above example, the preprocessor copies the preprocessed code of stdio.h to our file. The .h files are called header files in C. These header files generally contain declarations of functions. We need stdio.h for the function printf() used in the program. 
 </li>  <hr />
 <li> <b>Line 2 [ int main(void) ] </b> There must be a starting point from where execution of compiled C program begins. In C, the execution typically begins with the first line of main(). The void written in brackets indicates that the main doesn’t take any parameter (See this for more details). main() can be written to take parameters also. We will be covering that in future posts. 
The int was written before main indicates return type of main(). The value returned by main indicates the status of program termination. See this post for more details on the return type. </li>
<hr /><li><b>Line 3 and 6: [ &#123; and &#125; ] </b> In C language, a pair of curly brackets define scope and are mainly used in functions and control statements like if, else, loops. All functions must start and end with curly brackets. </li>
<hr /><li><b>Line 4 [ printf(“NooB- Geeks”); ]</b>is a standard library function to print something on standard output. The semicolon at the end of printf indicates line termination. In C, a semicolon is always used to indicate end of a statement. </li>
<hr /><li><b>Line 5 [ return 0; ] </b>  The return statement returns the value from main(). The returned value may be used by an operating system to know the termination status of your program. The value 0 typically means successful termination.</li>
 </ol>
       </div>
    )
    
   
}

export default Template
